import React, { createContext, useContext, useState } from 'react';

const HeaderContext = createContext();

export const useHeader = () => {
  const context = useContext(HeaderContext);
  // If there's no provider (some public routes / storybook / tests),
  // return a safe noop implementation so callers don't throw.
  if (!context) {
    return {
      headerProps: {},
      setHeaderProps: () => {},
    };
  }
  return context;
};

export const HeaderProvider = ({ children }) => {
  const [headerProps, setHeaderProps] = useState({
    title: '',
    subtitle: '',
    rightElement: null,
    user: null,
    userId: null,
    onNotificationClick: null
  });

  return (
    <HeaderContext.Provider value={{ headerProps, setHeaderProps }}>
      {children}
    </HeaderContext.Provider>
  );
};